module.exports = __webpack_public_path__ + "img/banner-ph.315f61b.jpg";